export default "__VITE_ASSET__6bTR10kP__"